var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.zh_CN}},[_c('div',{attrs:{"id":"app"}},[_c('public-header',{attrs:{"isOpacity":_vm.$store.state.isOpacity}}),_c('router-view'),_c('public-footer'),_c('action-side')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }